import { config as faConfig } from '@fortawesome/fontawesome-svg-core';
import * as SentryBrowser from '@sentry/browser';
import rootSagas from 'mk2/apps/forum/sagas';
import { appInit } from 'mk2/client/init';
import Application from 'mk2/containers/Application/Application';
import { routes } from 'mk2/router';
import { initSentry } from 'mk2/sentry';

initSentry(SentryBrowser);

// svg styles are already included, don't load again
faConfig.autoAddCss = false;

appInit(
    Application,
    routes,
    rootSagas,
).then((rerender) => {
    if (module.hot) {
        module.hot.accept(['mk2/containers/Application/Application', 'mk2/router'], () => {
            const NextApp = require('mk2/containers/Application/Application').default;
            rerender(NextApp);
        });
    }
});
